/** `rgba()` of a `#RRGGBB` token, for tints the palette does not carry under their own key. */
export const withAlpha = (hex: string, alpha: number): string => {
  const [r, g, b] = [1, 3, 5].map((offset) => parseInt(hex.slice(offset, offset + 2), 16));

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
